export default function(){
    jQuery(document).on('click', '.potw-voting-action', function(){
        if(jQuery(this).hasClass('disabled')) return;

        let product_id  = jQuery(this).data('product');
        let $csrf       = jQuery('input[name="_vote_csrf"]');

        jQuery.ajax({
            method: 'POST',
            dataType: 'json',
            url: '/pizzaVote',
            data: {
                product_id: product_id,
                '_token': $csrf.val()
            }
        }).always(function(res){
            window.location.reload();
        });
    });

    jQuery('.potw-voting-chosen-item').each(function(){
        jQuery('html, body').animate({
            scrollTop: jQuery(this).offset().top - 150
        }, 1000);
    });

    
    jQuery('.potw-aftervote-popup').each(function(){
        let $e      = jQuery(this);
        let $action = $e.find('.potw-aftervote-popup-action');

        $e.addClass('popup_show');

        setTimeout(function(){
            window.location.href = $action.attr('href');
        }, 5000);
    });
}